import React, { useState } from "react";
import AppPeriodNavigator from "../../../../components/AppPeriodNavigator";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const niceToKnowItems = [
  "Für Zeiträume auf einem Kalender – für das Blättern durch eine bekannte Liste ist AppNavigator zuständig.",
  "Die Beschriftung entsteht aus dem Datum und ist überall gleich: KW mit Datumsspanne, im Monat der ausgeschriebene Monat.",
  "In der Wochenansicht ist die KW bewusst kleiner und heller als die Datumsspanne – sie dient nur als ergänzende Orientierung.",
  "Die Schritte führt die Seite aus (onPreviousPeriod/onNextPeriod): nur sie weiss, ob ihr Zustand ein Datum, ein Wochenstart oder ein Monat ist.",
  "Woche/Monat erscheint nur, wenn onViewModeChange gesetzt ist – Seiten mit nur einem Zeitraum lassen es weg.",
  "Im Auswahlfenster ist der laufende Zeitraum mit einem Punkt markiert, der gewählte farbig.",
  "Die Breite des Auslösers hält die Reihe beim Blättern ruhig; für enge Stellen über --ds-period-trigger-min-width anpassen.",
];

function addDays(date, days) {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

function addMonths(date, months) {
  const next = new Date(date);
  next.setMonth(next.getMonth() + months);
  return next;
}

function PreviewExample({ label, hint, children }) {
  return (
    <div className="ds-docs-period-preview__example">
      <div className="ds-docs-period-preview__caption">
        <span className="ds-docs-preview-row__label">{label}</span>
        <span className="ds-docs-period-preview__hint">{hint}</span>
      </div>
      {children}
    </div>
  );
}

export default function PeriodNavigatorsDocs() {
  const [bothViewsDate, setBothViewsDate] = useState(() => new Date());
  const [viewMode, setViewMode] = useState("week");
  const [weekDate, setWeekDate] = useState(() => new Date());
  const [monthDate, setMonthDate] = useState(() => new Date());

  const stepBothViews = (date, direction) =>
    viewMode === "week" ? addDays(date, direction * 7) : addMonths(date, direction);

  return (
    <DocsSectionCard title="Period Navigators">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-period-preview">
            <PreviewExample label="Woche & Monat" hint="Seiten, die beide Ansichten führen">
              <AppPeriodNavigator
                viewMode={viewMode}
                referenceDate={bothViewsDate}
                onPreviousPeriod={() => setBothViewsDate((current) => stepBothViews(current, -1))}
                onNextPeriod={() => setBothViewsDate((current) => stepBothViews(current, 1))}
                onSelectDate={setBothViewsDate}
                onViewModeChange={setViewMode}
              />
            </PreviewExample>

            <PreviewExample label="Nur Woche" hint="Ohne onViewModeChange entfällt die Umschaltung">
              <AppPeriodNavigator
                viewMode="week"
                referenceDate={weekDate}
                onPreviousPeriod={() => setWeekDate((current) => addDays(current, -7))}
                onNextPeriod={() => setWeekDate((current) => addDays(current, 7))}
                onSelectDate={setWeekDate}
              />
            </PreviewExample>

            <PreviewExample label="Nur Monat" hint="Zeitraum als ausgeschriebener Monat">
              <AppPeriodNavigator
                viewMode="month"
                referenceDate={monthDate}
                onPreviousPeriod={() => setMonthDate((current) => addMonths(current, -1))}
                onNextPeriod={() => setMonthDate((current) => addMonths(current, 1))}
                onSelectDate={setMonthDate}
              />
            </PreviewExample>

            <PreviewExample label="Grösse SM" hint="Für dichte Leisten – Standard ist MD">
              <AppPeriodNavigator
                size="sm"
                viewMode="month"
                referenceDate={monthDate}
                onPreviousPeriod={() => setMonthDate((current) => addMonths(current, -1))}
                onNextPeriod={() => setMonthDate((current) => addMonths(current, 1))}
                onSelectDate={setMonthDate}
              />
            </PreviewExample>
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
